module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_04.fb179093.jpg";